import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginLeft: '7px',
    minHeight: '51px',
    cursor: 'pointer'
  },

  avatarHolder: {
    marginRight: '1rem'
  },

  avatar: {
    width: '2rem !important',
    height: '2rem !important',
    fontSize: theme.size.sm
  },

  title: {
    marginLeft: '10px',
    fontSize: theme.size.sm,
    color: '#323436'
  },

  faded: {
    color: 'inherit',
    opacity: '0.35'
  },

  counts: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',

    '& > :not(:last-child)': {
      marginRight: '10px'
    }
  },

  count: {
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',

    '& .count': {
      marginRight: '4px'
    },

    '& .icon': {
      display: 'flex',
      alignItems: 'center',
      //@ts-ignore
      color: theme.palette.textAlt
    }
  }
}))

export default useStyles
